import {
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_ERROR
  } from "./DeleteUserTypes";
  
  const initialState = {
    loading: false,
    isError: false,
    successMessage: "",
    errorMessage: "",
    deleteUser: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case DELETE_USER_REQUEST:
        return {
          ...state,
          isError: false,
          loading: true
        };
      case DELETE_USER_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isError: false,
          deleteUser: action.payload,
          successMessage: "User deleted successfully!",
          errorMessage: ""
        };
      case DELETE_USER_ERROR:
        return {
          ...state,
          loading: false,
          isError: true,
          deleteUser: [],
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  